import { PET_ENABLED } from './config.js';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../auth/useAuth.js';
import { AUTH_MODE } from '../auth/firebase.js';
import { teachersPetPractice } from '../lib/callables.js';
// Shared by pooled and Guide-linked practice. The server grades raw answers and owns the daily ledger.
export function usePetPracticeReward() {
  const { packId } = useParams(), { currentUser } = useAuth();
  const [reward, setReward] = useState('');
  const generation = useRef(0);
  useEffect(() => { generation.current++; setReward(''); return () => { generation.current++; }; }, [packId, currentUser?.uid]);
  const checkReward = raw => {
    if (!PET_ENABLED || AUTH_MODE === 'mock' || !currentUser?.uid || !packId || raw.length < 3) return;
    const requestGeneration = generation.current;
    teachersPetPractice({ packId, answers: raw }).then(r => {
      if (requestGeneration === generation.current && r.award) setReward(r.award + ' daily learning coins added to Teacher’s Pet.');
    }).catch(() => { if (requestGeneration === generation.current) setReward('Pet reward could not be checked. Your practice remains available.'); });
  };
  return { reward, checkReward };
}
